import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../its/services/authentication.service';
import { LayoutService } from './service/app.layout.service';
import { User } from '../its/models/user';
import { UserJsonDTO } from '../its/models/userJsonDTO';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-supportmenu',
    templateUrl: './app.supportsidebar.component.html',
    providers: [MessageService]
})
export class AppSupportSidebarComponent implements OnInit{

  userlogged:User;
  objResponse: UserJsonDTO = new UserJsonDTO();
  deleteUserDialog: boolean = false;
  message: string;
    
    
    constructor( public layoutService: LayoutService, 
                 public authenticationService: AuthenticationService,
                 private messageService: MessageService) {

    }
    ngOnInit(): void {
        this.userlogged = this.authenticationService.getUserValue;
    }

    get visible(): boolean {
        return this.layoutService.state.supportSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.supportSidebarVisible = _val;
    }

    sendMessage(){
      this.authenticationService.sendContactMessage(this.userlogged.email, `${this.userlogged.lastName} ${this.userlogged.firstName}`, this.message)
                .subscribe({
                    next: () => { 
                      this.messageService.add({ severity: 'success', summary: 'Operazione avvenuta con successo.', detail: 'Messaggio inviato.', life: 3000 });
                      setTimeout(() => { this.visible = false; }, 3000); 
                     },
                    error: error => {
                      console.log(error);
                      this.messageService.add({severity:'error', summary:'Operazione non riuscita.', detail:'Invio del messaggio non riuscito.', life: 3000});
                      setTimeout(() => { this.visible = false; }, 3000);
                    }
                });
    }
    

}